import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';

import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';

import { PdpSharedBuyerIncentives } from '../../shared/PdpSharedBuyerIncentives/PdpSharedBuyerIncentives';
import { PdpSharedBuyerIncentivesLink } from '../../shared/PdpSharedBuyerIncentivesLink/PdpSharedBuyerIncentivesLink';
import { PdpSharedDivider } from '../../shared/PdpSharedDivider/PdpSharedDivider';

import { PdpBuyerIncentivesModal_user$key } from './__generated__/PdpBuyerIncentivesModal_user.graphql';

import dibsCss from 'dibs-css';
import classnames from 'classnames';

const userFragment = graphql`
    fragment PdpBuyerIncentivesModal_user on User {
        ...PdpSharedBuyerIncentives_user
    }
`;

export const PdpBuyerIncentivesModal: FC<{
    user?: PdpBuyerIncentivesModal_user$key | null;
    isOpen: boolean;
    onClose: () => void;
}> = ({ user: userRef, isOpen, onClose }) => {
    const user = useFragment(userFragment, userRef);

    return (
        <ModalContainer isOpen={isOpen} onClose={onClose}>
            <ModalCloseButton onClick={onClose} />
            <ModalBody>
                <div className={classnames(dibsCss.textCenter, dibsCss.mbSmall)}>
                    <div className={classnames(dibsCss.sassyFontHeaderLarge, dibsCss.mbXxsmall)}>
                        <FormattedMessage
                            id="abf.pdp.PdpBuyerIncentivesModal.title"
                            defaultMessage="The 1stDibs Promise"
                        />
                    </div>
                    <PdpSharedBuyerIncentivesLink />
                </div>
                <PdpSharedDivider isViewportWidth />
                <div className={dibsCss.mbSmall} />
                <PdpSharedBuyerIncentives showLearnMoreLink={false} user={user} />
            </ModalBody>
        </ModalContainer>
    );
};
